import React from "react";
import {
  formatStatsValue,
  getAriaLabel,
  getMetricId,
  getStatsBgColor,
  getStatsIcon,
  getStatsLabel,
} from "../PayroleMocks";

const PPMetricsCards = ({ metrics }) => {
  const metricsToRender =
    metrics && typeof metrics === "object" && !Array.isArray(metrics)
      ? Object.entries(metrics).map(([key, value]) => ({
          id: getMetricId(key),
          label: getStatsLabel(key),
          value: formatStatsValue(key, value),
          icon: getStatsIcon(key),
          bgColor: getStatsBgColor(key),
        }))
      : metrics || [];

  return (
    <div className="pp-metrics-cards-container">
      {metricsToRender.map((m) => {
        const isCurrency = m.id === "payout";

        return (
          <div
            className="pp-metrics-card"
            tabIndex={0}
            aria-label={getAriaLabel(m.label, m.value)}
            key={m.id}
          >
            <span
              className="pp-metrics-icon"
              style={{ background: m.bgColor }}
              aria-hidden="true"
            >
              {m.icon}
            </span>
            <span className="pp-metrics-texts">
              <span className="pp-metrics-label">{m.label}</span>
              <span
                className={
                  "pp-metrics-value" +
                  (m.id === "approvals" ? " pp-approvals" : "")
                }
              >
                {isCurrency ? (
                  <>
                    <span className="pp-metrics-currency">
                      {String(m.value).replace(/[\d,\.]/g, "")}
                    </span>
                    {Number(
                      String(m.value).replace(/[^\d\.]/g, "")
                    ).toLocaleString("en-IN")}
                  </>
                ) : (
                  m.value
                )}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default PPMetricsCards;